import { EventTypes } from '@mc/track-event'
import { paths } from '@mc/paths'

export type PageEventNameType = ReturnType<typeof getPageEventName>

export const getPageEventName = () => {
  const { pathname } = window.location

  if (pathname === paths.root) {
    return EventTypes.HOMEPAGE_CLICK
  }

  if (
    pathname.startsWith(paths.classPage('')) ||
    pathname.startsWith(paths.seriesPage(''))
  ) {
    return EventTypes.COURSE_MARKETING_CLICK
  }

  // must be checked before /categories due to increased specificity of prefix
  if (pathname.startsWith(paths.category(''))) {
    return EventTypes.CATEGORY_PAGE_CLICK
  }

  if (pathname === paths.categories) {
    return EventTypes.CATALOG_PAGE_CLICK
  }

  if (pathname.startsWith(paths.classRecommendationsResults)) {
    return EventTypes.QUIZ_RESULTS_PAGE_CLICK
  }

  // must be checked before /sessions due to increased specificity of prefix
  if (pathname.startsWith(paths.sessionsClassHome(''))) {
    return EventTypes.SESSION_COURSE_MARKETING_PAGE_CLICK
  }

  if (pathname === paths.sessions()) {
    return EventTypes.EXPLAINER_PAGE_CLICK
  }

  if (pathname.startsWith(paths.subcategoryPage(''))) {
    return EventTypes.SUBCATEGORY_PAGE_CLICK
  }

  if (pathname.startsWith(paths.outcomePage(''))) {
    return EventTypes.OUTCOME_PAGE_CLICK
  }

  if (pathname.startsWith(paths.gift)) {
    return EventTypes.GIFT_PAGE_CLICK
  }

  if (pathname.startsWith(paths.bogo) || pathname.startsWith(paths.promotion)) {
    return EventTypes.HOLIDAY_PAGE_CLICK
  }

  return EventTypes.COURSE_MARKETING_CLICK
}
